import RouteViolationRecord from '@/orm/models/RouteViolationRecord'
/**
 * Shared Component properties for the route components
 */

var RouteComponentMixin = {
  methods: {
    /**
     * Returns a list of violations excluding no-data violations shorter than
     * the minimum duration
     *
     * @return array
     */
    filterTimeGapViolations (violations) {
      // Remove data gap violations that don't meet the customer's minimum
      // duration requirements
      const dataGapFatalDuration = this.$store.getters['userModule/customerContext'].getSetting('data_gap_fatal_duration', 40)
      return violations.filter(violation => {
        return !(violation.type === RouteViolationRecord.TYPE_GAP && violation.duration < dataGapFatalDuration * 60)
      })
    }
  }
}

export default RouteComponentMixin
